import { memo } from 'react'
import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from '@xyflow/react'

interface FlowEdgeData {
  amount: number
  unit: string
}

function FlowEdgeComponent({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  const edgeData = data as unknown as FlowEdgeData | undefined

  // Format amount with appropriate precision
  const formatAmount = (amount: number): string => {
    if (Math.abs(amount) >= 1000) {
      return amount.toLocaleString(undefined, { maximumFractionDigits: 0 })
    }
    if (Math.abs(amount) >= 1) {
      return amount.toLocaleString(undefined, { maximumFractionDigits: 2 })
    }
    if (Math.abs(amount) >= 0.001) {
      return amount.toLocaleString(undefined, { maximumFractionDigits: 4 })
    }
    return amount.toExponential(2)
  }

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: '#8b5cf6',
          strokeWidth: 3,
          animation: 'flowAnimation 1s linear infinite',
        }}
      />
      {edgeData && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="px-2 py-1 rounded-md bg-violet-500/90 text-white text-xs font-medium shadow-lg border border-violet-400/50"
          >
            {formatAmount(edgeData.amount)} {edgeData.unit}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  )
}

export const FlowEdge = memo(FlowEdgeComponent)
